import { PERSIST_LONG_EXPIRY_DEFAULT, PERSIST_SHORT_EXPIRY_DEFAULT } from './consts';

// CAPSULE MODELS
export const SCHEMAS = {
  Account: {
    barcodePrefix: 'AC',
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AccountActivityFeedItem: {
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  PaymentCard: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AccountLogin: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AccountMessage: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AccountPasswordReset: {
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  Affiliate: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AffiliateModerator: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AffiliateSubgroup: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  AvailableDeliveryWindow: {
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  Cart: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  DeliverableZipCodes: {
    expiry: null,
  },
  DeliveryAddress: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: ['name', 'street', 'street_two', 'city', 'state', 'zip_code', 'notes', 'is_doorman', 'is_active'],
  },
  DeliveryWindow: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  DeliveryZone: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  DrugName: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Escript: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  HomeScreenItem: {
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  Identity: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  IdentificationPhoto: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Insurance: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  InsurancePhotoGetUrl: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  InsurancePhotoPutUrl: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  InsuranceLookup: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Lead: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Medication: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: [
      'dosage_form_label',
      'gcdf',
      'gcn_seqno',
      'gcrt',
      'gcrt_desc',
      'gni',
      'hicl_seqno',
      'primary_name',
      'secondary_name',
      'strength',
    ],
  },
  PatientMedication: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: [
      'customer_facing_status',
      'is_hidden',
      'next_refill_date',
      'num_fills_remaining',
      'primary_name',
      'quantity_remaining',
      'secondary_name',
      'standard_fill_size',
    ],
  },
  NDCMedication: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  NdcStandardDrug: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  NewPrescription: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  NewPrescriptionFulfillment: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  NextTemplate: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Note: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Order: {
    barcodePrefix: 'OR',
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
    attributes: [
      'status',
      'on_hold',
      'verify_id',
      'created_at',
      'subtotal',
      'status_processing_at',
      'status_completed_at',
      'is_pack_verified_by_barcode',
    ],
  },
  OrderItem: {
    barcodePrefix: 'OI',
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Patient: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  PatientNote: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  PatientAffiliate: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Permission: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: ['name', 'codename'],
  },
  Pratice: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Prescription: {
    barcodePrefix: 'PX',
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: [
      'national_drug_code',
      'dispense_as_written',
      'instructions',
      'quantity',
      'num_days_supply',
      'auto_refill',
      'num_fills_total',
      'dosage',
      'drug_display_name_primary',
      'drug_display_name_secondary',
      'control_schedule',
      'expiration_date',
      'patient_id',
      'prescription_type',
      'usage_frequency',
      'is_hidden',
      'provider_id',
      'pioneer_rx_number',
      'pioneer_refillnumber',
      'should_process_refill',
      'next_refill_date',
      'quantity_remaining',
      'dosage_form_label',
      'quantity_prescribed',
      'standard_fill_size',
    ],
  },
  PrescriptionFulfillment: {
    barcodePrefix: 'PF',
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: [
      'checkout_end_date',
      'checkout_link_sent_at',
      'checkout_start_date',
      'delivery_date',
      'dispense_as_written',
      'ndc_dispensed_dosage',
      'ndc_dispensed_primary_name',
      'num_days_supply',
      'pioneer_rx_id',
      'pioneer_rx_transaction_fk',
      'price',
      'price_at_checkout',
      'quantity_dispensed',
      'should_waive_copay',
      'status',
      'status_claimed_at',
      'status_completed_at',
      'status_need_contact_info_at',
      'status_need_insurance_at',
      'status_not_needed_at',
      'status_not_responsive_at',
      'status_on_hold_at',
      'status_ordering_at',
      'status_prior_auth_at',
      'status_refill_too_soon_at',
      'status_revoked_at',
    ],
  },
  PrescriptionPhotoGetUrl: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  PrescriptionTransfer: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  PriorAuthorization: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Product: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Provider: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  ProviderActivityFeedItem: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  StandardDrug: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  StateTransition: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  Task: {
    barcodePrefix: 'TK',
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  TaskPreview: {
    barcodePrefix: 'TP',
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  Template: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  User: {
    barcodePrefix: 'US',
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  UserRegistrationToken: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
};
